export const GET_COUPON_DETAIL_LIST_REQUEST = "get_coupon_detail_list_request";
export const GET_COUPON_DETAIL_LIST_RESPONSE =
  "get_coupon_detail_list_response";

export const ADD_COUPON_DETAIL_REQUEST = "add_coupon_detail_request";
export const ADD_COUPON_DETAIL_RESPONSE = "add_coupon_detail_response";

export const UPDATE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_REQUEST =
  "update_coupon_detail_by_coupon_detail_id_request";
export const UPDATE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_RESPONSE =
  "update_coupon_detail_by_coupon_detail_id_response";

export const DELETE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_REQUEST =
  "delete_coupon_detail_by_coupon_detail_id_request";
export const DELETE_COUPON_DETAIL_BY_COUPON_DETAIL_ID_RESPONSE =
  "delete_coupon_detail_by_coupon_detail_id_response";

export const UPDATE_COUPON_DETAIL_STATUS_BY_COUPON_DETAIL_ID_REQUEST =
  "update_coupon_detail_status_by_coupon_detail_id_request";
export const UPDATE_COUPON_DETAIL_STATUS_BY_COUPON_DETAIL_ID_RESPONSE =
  "update_coupon_detail_status_by_coupon_detail_id_response";
